import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request, METHOD } from '@/utils/request';
/**
 * 报修登记
 */
export function saveRepairRegistration(_x) {
  return _saveRepairRegistration.apply(this, arguments);
}

/**
 * 列表报修提交
 */
function _saveRepairRegistration() {
  _saveRepairRegistration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(parma) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request("/repair/saveRepairRegistration", METHOD.POST, {
            id: parma.id,
            typeId: parma.formObject.typeId,
            makeServiceDate: parma.makeServiceDate,
            organId: parma.formObject.organId,
            postId: parma.formObject.postId,
            itemName: parma.itemName,
            location: parma.location,
            description: parma.description,
            faultImgList: parma.faultImgList,
            itemModel: parma.itemModel,
            repairsStatus: parma.repairsStatus,
            phone: parma.createPersonPhone,
            itemNum: parma.equipmentNumber,
            reDate: parma.faultTime
          }));
      }
    }, _callee);
  }));
  return _saveRepairRegistration.apply(this, arguments);
}
export function subRepairRegistration(_x2) {
  return _subRepairRegistration.apply(this, arguments);
}
/**
 * 报修修改登记
 */
function _subRepairRegistration() {
  _subRepairRegistration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parma) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/repair/subRepairRegistration", METHOD.POST, {
            id: parma.id
          }));
      }
    }, _callee2);
  }));
  return _subRepairRegistration.apply(this, arguments);
}
export function editSaveRepairRegistration(_x3) {
  return _editSaveRepairRegistration.apply(this, arguments);
}
/**
 * 查询报修登记列表
 */
function _editSaveRepairRegistration() {
  _editSaveRepairRegistration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(parma) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/repair/saveRepairRegistration", METHOD.POST, {
            id: parma.id,
            typeId: parma.typeId,
            makeServiceDate: parma.makeServiceDate,
            organId: parma.organId,
            postId: parma.postId,
            itemName: parma.itemName,
            location: parma.location,
            description: parma.description,
            faultImgList: parma.editSaveList,
            itemModel: parma.itemModel,
            repairsStatus: parma.repairsStatus,
            phone: parma.phone,
            itemNum: parma.itemNum,
            reDate: parma.reDate
          }));
      }
    }, _callee3);
  }));
  return _editSaveRepairRegistration.apply(this, arguments);
}
export function queryRepair(_x4, _x5, _x6) {
  return _queryRepair.apply(this, arguments);
}
/**
 * 删除报修登记
 */
function _queryRepair() {
  _queryRepair = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(current, pageSize, parma) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/repair/queryRepair", METHOD.POST, {
            startTime: parma.startTime,
            endTime: parma.endTime,
            repairsStatus: parma.repairsStatus,
            queryStr: parma.queryStr,
            currentNo: current,
            pageSize: pageSize
          }));
      }
    }, _callee4);
  }));
  return _queryRepair.apply(this, arguments);
}
export function delRepairRegistration(_x7) {
  return _delRepairRegistration.apply(this, arguments);
}

/**
 * 报修查看详情
 */
function _delRepairRegistration() {
  _delRepairRegistration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(parma) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/repair/delRepairRegistration", METHOD.POST, {
            id: parma
          }));
      }
    }, _callee5);
  }));
  return _delRepairRegistration.apply(this, arguments);
}
export function queryRepairDetail(_x8) {
  return _queryRepairDetail.apply(this, arguments);
}

/**
 * 查询报修单列表
 */
function _queryRepairDetail() {
  _queryRepairDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(parma) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request("/repair/queryRepairDetail", METHOD.POST, {
            id: parma
          }));
      }
    }, _callee6);
  }));
  return _queryRepairDetail.apply(this, arguments);
}
export function queryRepairRecord(_x9, _x0, _x1) {
  return _queryRepairRecord.apply(this, arguments);
}

/**
 * 查询接单列表
 */
function _queryRepairRecord() {
  _queryRepairRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(current, pageSize, parma) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request("/repair/queryRepairRecord", METHOD.POST, {
            startTime: parma.startTime,
            endTime: parma.endTime,
            repairsStatus: parma.repairsStatus,
            queryStr: parma.queryStr,
            type: parma.type,
            currentNo: current,
            pageSize: pageSize
          }));
      }
    }, _callee7);
  }));
  return _queryRepairRecord.apply(this, arguments);
}
export function queryRepairAppoint(_x10, _x11, _x12) {
  return _queryRepairAppoint.apply(this, arguments);
}

/**
 * 报修受理
 */
function _queryRepairAppoint() {
  _queryRepairAppoint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(current, pageSize, parma) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request("/repair/queryRepairAppoint", METHOD.POST, {
            startTime: parma.startTime,
            endTime: parma.endTime,
            repairsStatus: parma.repairsStatus,
            queryStr: parma.queryStr,
            currentNo: current,
            pageSize: pageSize
          }));
      }
    }, _callee8);
  }));
  return _queryRepairAppoint.apply(this, arguments);
}
export function acceptance(_x13) {
  return _acceptance.apply(this, arguments);
}

/**
 * 获取维修人员信息
 */
function _acceptance() {
  _acceptance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(parma) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request("/repair/acceptance", METHOD.POST, {
            id: parma.id,
            remark: parma.remarksContent,
            status: parma.status,
            type: parma.category,
            maintainuser: parma.maintainuser,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee9);
  }));
  return _acceptance.apply(this, arguments);
}
export function queryRepairPerson() {
  return _queryRepairPerson.apply(this, arguments);
}

/**
 * 派单
 */
function _queryRepairPerson() {
  _queryRepairPerson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request("/repair/queryRepairPerson", METHOD.POST));
      }
    }, _callee0);
  }));
  return _queryRepairPerson.apply(this, arguments);
}
export function repairDispatch(_x14) {
  return _repairDispatch.apply(this, arguments);
}

/**
 * 接单
 */
function _repairDispatch() {
  _repairDispatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(parma) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request("/repair/repairDispatch", METHOD.POST, {
            id: parma.id,
            userId: parma.servicePerson,
            remark: parma.remarksContent,
            status: parma.status,
            type: parma.type,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee1);
  }));
  return _repairDispatch.apply(this, arguments);
}
export function orderTaking(_x15) {
  return _orderTaking.apply(this, arguments);
}

/**
 * 完工反馈
 */
function _orderTaking() {
  _orderTaking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(parma) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request("/repair/orderTaking", METHOD.POST, {
            id: parma.id,
            remark: parma.orderRemark,
            status: parma.status,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee10);
  }));
  return _orderTaking.apply(this, arguments);
}
export function saveCompleteSupplies(_x16) {
  return _saveCompleteSupplies.apply(this, arguments);
}

/**
 * 查看全部信息
 */
function _saveCompleteSupplies() {
  _saveCompleteSupplies = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(parma) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request("/repair/saveCompleteSupplies", METHOD.POST, {
            fillId: parma.fillId,
            remark: parma.feedbackRemark,
            type: parma.status,
            repairDate: parma.repairDate,
            supplies: parma.partsList.matterList,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee11);
  }));
  return _saveCompleteSupplies.apply(this, arguments);
}
export function repairAll(_x17) {
  return _repairAll.apply(this, arguments);
}

/**
 * 评价
 */
function _repairAll() {
  _repairAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(parma) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request("/repair/repairAll", METHOD.POST, {
            id: parma
          }));
      }
    }, _callee12);
  }));
  return _repairAll.apply(this, arguments);
}
export function evaluate(_x18) {
  return _evaluate.apply(this, arguments);
}

/**
 * 打印
 */
function _evaluate() {
  _evaluate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(parma) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request("/repair/evaluate", METHOD.POST, {
            fillId: parma.fillId,
            isRepair: parma.isRepair,
            speed: parma.speed,
            attitude: parma.attitude,
            technicallevel: parma.technicallevel,
            quality: parma.quality,
            evaluate: parma.evaluate,
            remark: parma.remark,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee13);
  }));
  return _evaluate.apply(this, arguments);
}
export function printRepair(_x19) {
  return _printRepair.apply(this, arguments);
}

/**
 * 补录
 */
function _printRepair() {
  _printRepair = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(parma) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request("/repair/printRepair", METHOD.POST, {
            id: parma
          }));
      }
    }, _callee14);
  }));
  return _printRepair.apply(this, arguments);
}
export function saveSupplement(_x20) {
  return _saveSupplement.apply(this, arguments);
}

/**
 * 文件上传
 */
function _saveSupplement() {
  _saveSupplement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(parma) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request("/repair/saveSupplement", METHOD.POST, {
            typeId: parma.organPostId.typeId,
            userId: parma.organPostId.userId,
            organId: parma.organPostId.organId,
            postId: parma.organPostId.postId,
            phone: parma.phone,
            itemNum: parma.itemNum,
            type: parma.status,
            itemName: parma.itemName,
            reDate: parma.reDate,
            location: parma.location,
            description: parma.description,
            itemModel: parma.itemModel,
            comUserId: parma.comUserId,
            repairDate: parma.repairDate,
            remark: parma.remark,
            comType: parma.comType,
            supplies: parma.supplies,
            faultImgList: parma.faultImgList
          }));
      }
    }, _callee15);
  }));
  return _saveSupplement.apply(this, arguments);
}
export function batchUploadFile(_x21) {
  return _batchUploadFile.apply(this, arguments);
}

/**
 * 校外维修人员集合
 */
function _batchUploadFile() {
  _batchUploadFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(data) {
    var fromData;
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          fromData = new FormData();
          _.forEach(data, function (v, k) {
            fromData.append('files', v.file);
          });
          return _context16.a(2, request("/file/repairUploadFile", METHOD.POST, fromData));
      }
    }, _callee16);
  }));
  return _batchUploadFile.apply(this, arguments);
}
export function queryOuterPersonList(_x22) {
  return _queryOuterPersonList.apply(this, arguments);
}

/**
 * 列表查询校外人员
 */
function _queryOuterPersonList() {
  _queryOuterPersonList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(parma) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, request("/repair/queryOuterPersonList", METHOD.POST, {
            companyName: parma.companyName,
            perName: parma.perName
          }));
      }
    }, _callee17);
  }));
  return _queryOuterPersonList.apply(this, arguments);
}
export function queryOuterMaintainPersonPage(_x23, _x24, _x25) {
  return _queryOuterMaintainPersonPage.apply(this, arguments);
}

/**
 * 新增校外人员
 */
function _queryOuterMaintainPersonPage() {
  _queryOuterMaintainPersonPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(page, limit, param) {
    var data;
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            companyName: param.companyName,
            perName: param.perName,
            status: param.status
          };
          return _context18.a(2, request("/repair/queryOuterMaintainPersonPage", METHOD.POST, data));
      }
    }, _callee18);
  }));
  return _queryOuterMaintainPersonPage.apply(this, arguments);
}
export function addOuterMaintainPerson(_x26) {
  return _addOuterMaintainPerson.apply(this, arguments);
}

/**
 * 编辑校外人员
 */
function _addOuterMaintainPerson() {
  _addOuterMaintainPerson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(data) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, request("/repair/addOuterMaintainPerson", METHOD.POST, data));
      }
    }, _callee19);
  }));
  return _addOuterMaintainPerson.apply(this, arguments);
}
export function updateOuterMaintainPerson(_x27) {
  return _updateOuterMaintainPerson.apply(this, arguments);
}

/**
 * 启用停用校外人员
 */
function _updateOuterMaintainPerson() {
  _updateOuterMaintainPerson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(data) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, request("/repair/updateOuterMaintainPerson", METHOD.POST, data));
      }
    }, _callee20);
  }));
  return _updateOuterMaintainPerson.apply(this, arguments);
}
export function updateStatusOuterMaintainPerson(_x28) {
  return _updateStatusOuterMaintainPerson.apply(this, arguments);
}

/**
 * 删除校外人员
 */
function _updateStatusOuterMaintainPerson() {
  _updateStatusOuterMaintainPerson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(data) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, request("/repair/updateStatusOuterMaintainPerson", METHOD.POST, data));
      }
    }, _callee21);
  }));
  return _updateStatusOuterMaintainPerson.apply(this, arguments);
}
export function delOuterMaintainPerson(_x29) {
  return _delOuterMaintainPerson.apply(this, arguments);
}
function _delOuterMaintainPerson() {
  _delOuterMaintainPerson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(data) {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, request("/repair/delOuterMaintainPerson", METHOD.POST, data));
      }
    }, _callee22);
  }));
  return _delOuterMaintainPerson.apply(this, arguments);
}